"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkPermissions = void 0;
const __1 = require("..");
exports.checkPermissions = async (type, permissions) => {
    switch (type) {
        case __1.BeaconMessageType.OperationRequest:
            return permissions.includes(__1.PermissionScope.OPERATION_REQUEST);
        case __1.BeaconMessageType.SignPayloadRequest:
            return permissions.includes(__1.PermissionScope.SIGN);
        case __1.BeaconMessageType.PermissionRequest:
        case __1.BeaconMessageType.BroadcastRequest:
            return true;
        default:
            return false;
    }
};
//# sourceMappingURL=check-permissions.js.map